import { Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ComponentBreakpoint } from '../../../constants';

import { Desktop } from './desktop';
import { Mobile } from './mobile';

export interface SkeletonProps {
  viewportType: ComponentBreakpoint;
  renderCount: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ viewportType, renderCount }) => {
  const ResponsiveSkeleton = useBreakpointValue({
    base: <Mobile />,
    sm: <Desktop viewportType={viewportType} />,
  });

  return (
    <VStack space={Spacing['inline.xxxs']}>
      {Array.from({ length: renderCount }).map((_, index) => (
        <Shadow level={2} borderRadius={BoxRadius.sm} key={String(index)}>
          <HStack
            py={Spacing['inline.xxxs']}
            alignItems="center"
            borderRadius={BoxRadius.sm}
            pl={{ base: 0, sm: Spacing['inline.xxxs'] }}
            justifyContent={'center'}>
            {ResponsiveSkeleton}
          </HStack>
        </Shadow>
      ))}
    </VStack>
  );
};
